import { Icon } from '@hometap/htco-components';
import React from 'react';
import './UnderwriterBlockingErrors.scss';

type UnderwriterBlockingErrorsProps = {
  errors?: string[] | null;
};

export const UnderwriterBlockingErrors = ({ errors }: UnderwriterBlockingErrorsProps) =>
  !!errors?.length ? (
    <div className="UnderwriterBlockingErrors">
      <Icon className="UnderwriterBlockingErrorIcon" name="icon-error" />

      <div className="UnderwriterBlockingError">
        {errors.map((error, i) => (
          <span key={i}>{error}</span>
        ))}
      </div>
    </div>
  ) : null;
